export const RESET = Symbol('APP_RESET');
export const RESET_ORGANIZATION = Symbol('APP_RESET_ORGANISATION');

/**
 * Reset all stores of the app
 * @return {Object} - Action to reset the application
 */
export const clearApp = () => ({
	type: RESET,
});

/**
 * Reset the stores links to the organisation of the app
 * @return {Object} - Action to reset the organisation's data
 */
export const clearOrganisationData = () => ({
	type: RESET_ORGANIZATION,
});
